import { FC, useEffect, useState } from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import { useAppDataContext } from "@context/AppContext";
import StorageSelectionDialog from "@components/dialogs/StorageSelectionDialog";

const StorageIndicator: FC = () => {
  const { useLocalStorage, setUseLocalStorage } = useAppDataContext();
  const [availableLocalStorage, setAvailableLocalStorage] = useState(5000000);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    getLeftStorageSize().then((size) => {
      setAvailableLocalStorage(size);
    });
  }, [useLocalStorage]);

  const usedStorage = new Blob(Object.values(localStorage)).size;
  const totalStorage = availableLocalStorage + usedStorage;
  const percentUsed = (usedStorage / totalStorage) * 100;

  return (
    <Box sx={{ position: "relative" }}>
      <StorageSelectionDialog
        open={false}
        usedStorage={usedStorage}
        availableLocalStorage={availableLocalStorage}
        handleClose={(selectedStorage) => {
          setOpenDialog(false);
          setUseLocalStorage && setUseLocalStorage(selectedStorage === "local");
        }}
      />
      <LinearProgress
        variant={"determinate"}
        value={percentUsed}
        sx={{ height: "2rem" }}
        color={percentUsed < 80 ? "primary" : "error"}
        onClick={() => setOpenDialog(true)}
      />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          marginInline: "auto",
          width: "fit-content",
          height: "100%",
          alignContent: "center",
          color: "white",
        }}
      >
        <Typography>{`Speicher ${percentUsed.toFixed(0)}%`}</Typography>
      </Box>
    </Box>
  );
};

const getLeftStorageSize = async () => {
  const itemBackup = localStorage.getItem("");
  let increase = true;
  let data = "1";
  let totalData = "";
  let tryTotalData = "";
  while (true) {
    try {
      tryTotalData = totalData + data;
      localStorage.setItem("", tryTotalData);
      totalData = tryTotalData;
      if (increase) data += data;
    } catch (e) {
      if (data.length < 2) break;
      increase = false;
      data = data.substr(data.length / 2);
    }
  }
  if (itemBackup) {
    localStorage.setItem("", itemBackup);
  } else {
    localStorage.removeItem("");
  }

  return new Blob([totalData]).size;
};

export default StorageIndicator;
